import vatService from 'js/vue/api/taxes/vatService.js';

export default {
    namespaced: true,
    state() {
        return {
            taxes: [],
            listNoEcoTaxes: [],
            listEcoTaxes: [],
            vatSelected: 0,
            taxesSettings: null,
        };
    },
    getters: {
        taxes: (state) => state.taxes,
        vatSelected: (state) => state.vatSelected,
        listEcoTaxes: (state) => state.listEcoTaxes,
        listNoEcoTaxes: (state) => state.listNoEcoTaxes,
        taxesSettings: (state) => state.taxesSettings,
    },
    mutations: {
        setTaxes(state, payload) {
            state.taxes = payload;
        },
        setVatSelected(state, payload) {
            state.vatSelected = payload;
        },
        setListEcoTaxes(state, payload) {
            state.listEcoTaxes = payload;
        },
        setListNoEcoTaxes(state, payload) {
            state.listNoEcoTaxes = payload;
        },
        setSettingsTaxes(state, payload) {
            state.taxesSettings = payload;
        },
    },
    actions: {
        fetchTaxesSettings({ commit }) {
            return new Promise((resolve, reject) => {
                vatService.getSettingsTaxes().then((response) => {
                    commit('setSettingsTaxes', response.data);
                    resolve();
                });
            });
        },
        fetchTaxes({ commit }, params = { shouldGetEmbed: false, shouldGetEcoTax: false }) {
            return new Promise((resolve, reject) => {
                vatService
                    .getAllVat(0, params.shouldGetEmbed, params.shouldGetEcoTax)
                    .then((response) => {
                        for (const taxeIndex in response) {
                            response[taxeIndex].translations =
                                response[taxeIndex]._embed?.translations;
                        }
                        commit('setTaxes', response);
                        commit('setListNoEcoTaxes', [...response.filter((tax) => !tax.is_ecotax)]);
                        commit('setListEcoTaxes', [...response.filter((tax) => tax.is_ecotax)]);
                        commit('setVatSelected', response[0].id);
                        resolve();
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        updateTaxes({ commit }, taxes) {
            return new Promise((resolve, reject) => {
                vatService
                    .updateTaxes(taxes)
                    .then(() => {
                        resolve();
                    })
                    .catch((err) => reject(err));
            });
        },

        updateListTaxes({ commit }, taxes) {
            commit('setTaxes', taxes);
            commit('setListNoEcoTaxes', [...taxes.filter((tax) => !tax.is_ecotax)]);
            commit('setListEcoTaxes', [...taxes.filter((tax) => tax.is_ecotax)]);
        },
        updateListNoEcoTaxes({ commit }, taxes) {
            commit('setListNoEcoTaxes', taxes);
        },
        updateTaxesSettings({ commit, getters }) {
            return new Promise((resolve, reject) => {
                vatService
                    .updateTaxesSettings(getters.taxesSettings)
                    .then(() => {
                        resolve();
                    })
                    .catch(() => {
                        reject();
                    });
            });
        },
    },
};
